exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sideMenu{height:100%;position:fixed;background:#fff;z-index:251;top:0;right:0;overflow:scroll;border-radius:0 0 0 0!important}@media screen and (max-width:768px){.sideMenu{width:100%}}@media screen and (min-width:1280px){.sideMenu{width:30%}}.sideMenu .field{margin-bottom:0}.selectPlaceholder{color:#d5d5d5!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-584de9b1","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/components/empresas/components/SideMenu.vue
// module id = 2039
// module chunks = 2